const HOST = `https://api.3d-balkon.ru`;
const CONSTRUCTOR_URL = `https://create.3d-balkon.ru`;

export {
  HOST, CONSTRUCTOR_URL
}
